import { api } from '@/shared/api/axios';

export const simulationApi = {
  getConfig: (deploymentId) =>
    api.get(`/deployments/${deploymentId}/simulation/config`).then((r) => r.data.data),

  predict: (deploymentId, body) =>
    api.post(`/deployments/${deploymentId}/simulation/predict`, body).then((r) => r.data.data),

  getContextualOptimal: (deploymentId, body) =>
    api.post(`/deployments/${deploymentId}/simulation/optimal`, body).then((r) => r.data.data),
};
